import pkg from '../../package'
import program from 'commander'

program.
	usage('[options] <source>').
	version(pkg.version).
	// option('--php', '编译到php').
	option('-n --depth', '遍历深度').
	parse(process.argv)

if (program.args.length < 1) {
	program.help()
	process.exit(0)
}

import {transpile} from '..'
import walk from 'walkdir'
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
const transpileAll = (dir, depth) => {
	console.time('jedic')
	const tasks = []
	walk(dir, {max_depth: depth}, (path, stat) => {
		if (path.startsWith('.')) this.ignore()
	}).on('file', (filename, stat) => {
		if (filename.endsWith('.jedi')) tasks.push([filename, filename.slice(0, -4) + 'php', 'php'])
	}).on('end', async () => {
		const errors = [], list = []
		let running = 0
		for (const t of tasks) {
			while (running >= 32) {
				await sleep(60)
			}
			list.push(transpile(...t).then(() => --running).catch(e => { errors.push(e); --running }))
			++running
		}
		await Promise.all(list)
		console.timeEnd('jedic')
		if (errors.length > 0) {
			console.error(errors)
			process.exit(1)
		} else {
			process.exit(0)
		}
	})
}

transpileAll(program.args[0], program.depth)
